export default __webpack_public_path__ + "static/media/cardImg3.df213192.png";